import { fetcher, useSubmit } from "@certn/api";
import { components } from "@certn/api/generated-schemas/applicant-portal";
import { Loader, showToast } from "@certn/cascadia-react";
import { useTimeTracking } from "@certn/utils";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import { useEffectOnce } from "usehooks-ts";

import { ApplicationPage } from "./application";

export function Application() {
  const { caseId } = useParams();
  const { t } = useTranslation();
  const navigate = useNavigate();

  const starting = useRef(false);
  const [started, setStarted] = useState(false);
  const { submit } = useSubmit(`/api/internal/applicant/case/${caseId}/start/`);

  const { startTimeTracker, cancelTimeTracker } = useTimeTracking();

  useEffect(() => {
    startTimeTracker("application--submit");

    return () => {
      cancelTimeTracker("application--submit");
    };
  }, [startTimeTracker, cancelTimeTracker]);

  async function startApplication(caseId: string) {
    if (starting.current) {
      return;
    }

    starting.current = true;

    try {
      const { applicant_status } = await fetcher.request<{
        applicant_status: components["schemas"]["ApplicantStatusEnum"];
      }>(`/api/internal/applicant/case/${caseId}/`);

      if (
        [
          "CASE_ORDERED",
          "INVITE_UNDELIVERABLE",
          "APPLICANT_INVITED",
          "APPLICANT_OPENED",
        ].includes(applicant_status)
      ) {
        await submit();
      }

      setStarted(true);
    } catch {
      showToast(t("Invalid link"), {
        type: "info",
      });
      navigate("/");
    }
  }

  useEffectOnce(() => {
    caseId && startApplication(caseId);
  });

  if (!started) {
    return <Loader overlay />;
  }

  return <ApplicationPage />;
}
